<template>
  <m-card515 class="">
    <template #p-1>
      <h4 class=" content-card-title content-card-color font-weight-bolder">{{ content.title }}</h4>
      <span class="content-card-subtitle content-card-color" v-html="content.body"></span>
    </template>

    <template #p-2>
      <m-img :src="content.thumbnail" :alt="content.title"
             class=" float-left h1 content-card-image"/>
    </template>
  </m-card515>
</template>

<script>
import mCard515 from "../../Cards/Card515";
import mImg from '../../Tags/Img'

export default {
  name: "ContentCard515",
  props: {
    content: {}
  },
  components: {mCard515, mImg}
}
</script>

<style scoped>

.content-card-image {
  height: 60px;
  width: 60px
}

.content-card-color {
  color: var(--content-card515-color);
}

.content-card-subtitle {
  font-size: 12px;
}
</style>